<div class="content-wrapper">
    <app-system-alert></app-system-alert>

    @if(errorOnLogin) {
    <app-cf-alert [type]="AlertType.Error">The user was not found or the password was
        invalid.</app-cf-alert>
    }

    @if(featuresDisabled) {
    <app-cf-alert [type]="AlertType.Warning">{{featureMessage}}</app-cf-alert>
    }


    @if(!this.closedForMaintenance && this.signInPermitted) {
    @if(form) {
    <lib-metaform-display [form]="form" [showErrors]="false" [showButtons]="false"
        (formEvent)="onFormEvent($event)"></lib-metaform-display>
    }
    <div class="buttons">
        <app-cf-button [type]="ButtonType.SignIn" [style]="ButtonStyle.Wide" [enabled]="isValid" (click)="doSignIn()"
            [showProcessing]="isProcessing">Sign
            in</app-cf-button>
        <app-cf-button [type]="ButtonType.SignUp" [style]="ButtonStyle.Wide" [enabled]="signUpPermitted"
            (click)="doSignUp()">Sign
            up for CA</app-cf-button>
        <div class="button-bar cal">
            <app-cf-button [type]="ButtonType.Forgot" [style]="ButtonStyle.Wide" (click)="doReminder()">Forgotten
                password?</app-cf-button>
        </div>
    </div>
    }
</div>